import { type ComponentPropsWithoutRef, type ElementRef, type Ref } from 'react';
import { Input as HeroInput } from '@heroui/react';
import { cn } from '../utils';

type InputProps = ComponentPropsWithoutRef<typeof HeroInput>;

export const Input = ({
  ref,
  className,
  fullWidth = true,
  variant = 'secondary',
  ...props
}: InputProps & { ref?: Ref<ElementRef<typeof HeroInput>> }) => (
  <HeroInput
    ref={ref}
    fullWidth={fullWidth}
    variant={variant}
    className={cn('text-base sm:text-sm', className)}
    {...props}
  />
);

Input.displayName = 'Input';
export type { InputProps };
